import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector} from 'react-redux';
import { Button, Icon } from 'antd';
import InfiniteTable from '../Common/Table/InfiniteTable';
import { clearvailableReports, fetchAllReports, downloadCSV } from './ReportAction';
import './ReportDownload.scss';

const ReportDownload = () => {
    const dispatch = useDispatch();
    const [tableData, setTableData] = useState({});
    const authToken  = useSelector((state) => state?.auth?.loginDetails?.data?.token);  
    const downloadData =  useSelector((state) => state?.report.availableReports?.data || [] );

    useEffect(() => {
        dispatch(clearvailableReports())
    }, []);

    const downloadHeaders = [
        {
            key: 'reportName',
            title: 'Report Name',
            dataIndex: 'reportName',
            className: 'custom-width',
        },{
            key: 'taskStatus',
            title: 'Status',
            dataIndex: 'taskStatus',
            className: 'custom-width',
            render: (text) => {
                const statusColors = {
                    'COMPLETED': '#00CC88',
                    'PENDING': '#FFA500',
                    'FAILED': '#FF4444'
                };
                return (
                    <span style={{ color: statusColors[text] || '#666', fontWeight: '600' }}>
                        {text}
                    </span>
                );
            }
        },{
            key: 'createdDate',
            title: 'Created Date',
            dataIndex: 'createdDate',
            className: 'custom-width',
        },{
            key: 'id',
            title: 'Download',
            dataIndex: 'id',
            className: 'custom-width',
            render: (text, data) => {
                return data?.taskStatus === 'COMPLETED' ? (
                    <Button 
                        type="primary"
                        size="small"
                        onClick={()=> dispatch(downloadCSV(text, data.reportName))}
                        className="report-download-btn"
                    >
                        <Icon type="download" /> Download
                    </Button>
                ) : (
                    <span style={{ color: '#999' }}>—</span>
                );
            }
        }
    ];

    return (
        <div className="report-download-wrapper">
            <div className="dashboard-section">
                <h3>Available Reports</h3>
                <InfiniteTable
                    columns={downloadHeaders}
                    dataSource={downloadData}
                    tableDispatch={fetchAllReports}
                    props={{ increaseValue: 15, token: authToken }}
                    tableData={setTableData}
                    scroll={{ y: 300 }}
                />
            </div>
        </div>
    )
};

export default ReportDownload;

